import ManualPunchRequest from "../../../../components/company/performance/manual-punch-request";

export default function ManualPunchRequestPage(){
    return <ManualPunchRequest />
}